/* eslint-disable no-template-curly-in-string */
import { isValid, parse } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { addMethod, number, setLocale, string } from 'yup';

const countDecimals = (value) => {
  if (Math.floor(value) === value) return 0;
  return value.toString().split('.')[1].length || 0;
};

function useYupConfig() {
  const { t } = useTranslation();

  setLocale({
    mixed: {
      required: t('form.validation.missing_mandatory', { fieldName: '${path}' }),
      notType: t('form.validation.validation_error', { fieldName: '${path}' }),
    },
  });

  // The first argument must be a ref which contains the duplicated value
  addMethod(string, 'duplicated', function method(duplicatedValueRef, message) {
    return this.test({
      name: 'duplicated',
      test: (value) => value !== duplicatedValueRef.current,
      message: message ?? t('form.validation.duplicated_value', { fieldName: '${path}' }),
    });
  });

  // Used to validate a date string matches the given format or not
  addMethod(string, 'matchDateFormat', function method(format, message) {
    return this.test({
      name: 'matchDateFormat',
      test: (value) => {
        if (value === undefined) {
          return true;
        }
        const parsedDate = parse(value, format, new Date());
        return isValid(parsedDate);
      },
      message: message ?? t('form.validation.validation_error', { fieldName: '${path}' }),
    });
  });

  addMethod(number, 'maxDecimalPlaces', function method(decimalPlaces, message) {
    return this.test({
      name: 'maxDecimalPlaces',
      test: (value) => Number.isNaN(+value) || countDecimals(value) <= decimalPlaces,
      message: message ?? t('form.validation.max_decimal_places', { limit: decimalPlaces }),
    });
  });
}

export default useYupConfig;
